import React from 'react';
import Information from './components/Information';
import AdditionalInformation from './components/AdditionalInformation';
import { Button, Col, Form, message, Row } from 'antd';
import { useHistory } from 'react-router-dom';
import * as CommonService from '../../../services/CommonService';
import { CUSTOMER_ENDPOINT } from '../../../services/endpoint';

const CustomerCreate = (props) => {

	const { callback, onExit, showAdditional = true } = props;

	const history = useHistory();

	const handleSubmit = (e) => {
		e.preventDefault();
		props.form.validateFields((err, values) => {
			if (!err) {
				const body = {
					...values,
					debt: {
						amount: values.totalDebt
					}
				};
				delete body.totalDebt;
				window.setLoading(true);
				CommonService.create(CUSTOMER_ENDPOINT, body).then(res => {
					message.success('Thêm mới thành công');
					if (callback) {
						callback(res, props.form);
						return;
					}
					back();
				}).catch(err => {
					message.error(err?.data?.message);
				})
					.finally(() => {
						window.setLoading(false);
					});
			}
		});
	};

	const back = () => {
		history.push('/customer');
	};

	return (
		<div id={'product-create-page'}>
			<Form layout={'vertical'}>
				<Row gutter={12}>
					<Row>
						<Col>
							<Information form={props.form}
							/>
						</Col>
						{showAdditional && <Col>
							<AdditionalInformation form={props.form}
							/>
						</Col>}
					</Row>
				</Row>
				<div className={'btn-group mt-20'}>
					<Button type={'ghost'} onClick={() => onExit ? onExit(props.form) : back()}>Thoát</Button>
					<Button type={'primary'} onClick={handleSubmit}>Thêm khách hàng</Button>
				</div>
			</Form>
		</div>
	);
};

export default Form.create({ name: 'CustomerCreate' })(CustomerCreate);

